import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

/**
 * Service worker registration — and, more importantly, keeping it current.
 *
 * Registering once and walking away is how an installed app gets stuck. A home
 * screen app on iOS resumes from memory rather than re-navigating, so the
 * browser may go a long time without re-checking sw.js; meanwhile the old
 * worker keeps serving the old cached bundle. A deploy ships, production serves
 * the new build, and the installed app carries on showing the previous one with
 * no sign that anything is wrong. That's exactly what happened when the
 * notification prompt shipped and didn't appear on an already-installed phone.
 *
 * So: check for an update on load, and again every time the app comes back to
 * the foreground — which for a PWA is the moment that actually matters. When a
 * new worker takes control of a page an old one was already controlling, reload
 * once to pick up the new bundle.
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(reg => {
      console.log('[PWA] Service worker registered:', reg.scope);

      // Ask now, and whenever the app is brought back into view. Cheap: the
      // browser makes a conditional request and does nothing if sw.js is
      // unchanged.
      const checkForUpdate = () => { reg.update().catch(() => {}); };
      checkForUpdate();
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') checkForUpdate();
      });
    }).catch(err => {
      console.warn('[PWA] Service worker registration failed:', err);
    });

    // `controllerchange` fires when a new worker takes over. Only reload if a
    // worker was already in charge — on a first-ever visit the new worker
    // claiming the page is normal, and reloading then would be a pointless
    // flash. The flag guards against a reload loop if anything else triggers
    // another changeover.
    let reloading = false;
    const hadController = !!navigator.serviceWorker.controller;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hadController || reloading) return;
      reloading = true;
      console.log('[PWA] New version active, reloading');
      window.location.reload();
    });
  });
}
